export const teamLoaded = (state) => !!state.team

export const eventsLoaded = (state) => state.events.length > 0

export const rinksLoaded = (state) => state.rinks.length > 0

